import translations from './translations'

translations.add('es', {
    description: '¡Algo ha salido mal! Verifique los datos o inténtelo de nuevo más tarde.',
    close: 'CERRAR'
})
